import React, { useEffect, useState, useRef } from "react";
import MyChatBot from "./MyChatBot";
import { db } from "../sign_in/Firebase"; // ✅ adjust path as needed
import { collection, addDoc, query, orderBy, onSnapshot } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export default function SupportChat() {
  const auth = getAuth();
  const user = auth.currentUser;
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [showChatbot, setShowChatbot] = useState(false);
  const messagesEndRef = useRef(null);

  const userChatRef = user
    ? collection(db, "support_requests", user.uid, "messages")
    : null;

  useEffect(() => {
    if (!userChatRef) return;

    const q = query(userChatRef, orderBy("timestamp"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      scrollToBottom();
    });

    return () => unsubscribe();
  }, [userChatRef]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !userChatRef) return;

    await addDoc(userChatRef, {
      sender: "user",
      message: newMessage,
      timestamp: new Date(),
    });

    setNewMessage("");
  };

  if (!user) return <p>Please log in to use support chat.</p>;

  // 👉 Show Chatbot instead of Support
  if (showChatbot) {
    return (
      <div className="fixed bottom-8 left-8 z-50 w-80 h-[500px] bg-white rounded-lg shadow-xl overflow-hidden flex flex-col">
        <div className="bg-gray-100 text-sm text-center p-2 font-medium flex justify-between items-center">
          <span>Chatbot Assistant</span>
          <button
            onClick={() => setShowChatbot(false)}
            className="text-blue-600 hover:underline text-xs"
          >
            🔙 Back to Support
          </button>
        </div>
        <MyChatBot />
      </div>
    );
  }

  return (
    <div className="fixed bottom-8 left-8 z-50 w-80 max-h-[60vh] bg-white rounded-lg shadow-xl flex flex-col overflow-hidden">
      <div className="bg-blue-600 text-white p-3 font-semibold flex justify-between items-center">
        <span>Ask the team</span>
        <button
          onClick={() => setShowChatbot(true)}
          className="text-xs bg-white text-blue-600 px-2 py-1 rounded hover:bg-gray-100"
        >
          🤖 Chatbot
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-3 space-y-2">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`text-sm p-2 rounded-lg max-w-xs whitespace-pre-wrap ${
              msg.sender === "user"
                ? "bg-blue-100 self-end ml-auto"
                : "bg-gray-200 self-start mr-auto"
            }`}
          >
            {msg.message}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <form onSubmit={handleSend} className="p-2 flex border-t">
        <input
          type="text"
          className="flex-1 border rounded-lg px-3 py-1 text-sm focus:outline-none"
          placeholder="Type your message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <button
          type="submit"
          className="ml-2 bg-blue-600 text-white px-4 py-1 rounded-lg text-sm"
        >
          Send
        </button>
      </form>
    </div>
  );
}
